import { FC } from 'react';

type Props = {
	className?: string;
};

const ImageIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='inherit'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.14638 2C2.96097 2 2 2.96097 2 4.14638V15.8539C2 17.0394 2.96097 18.0003 4.14638 18.0003H15.8539C17.0394 18.0003 18.0003 17.0394 18.0003 15.8539V4.14638C18.0003 2.96097 17.0394 2 15.8539 2H4.14638ZM16.4765 15.7142C16.4765 16.135 16.1353 16.4762 15.7145 16.4762H5.96959L11.8306 11.2012C12.3609 10.724 13.1472 10.6669 13.7408 11.0627L16.4765 12.8865V15.7142ZM6.87815 8.43916C7.74027 8.43916 8.43916 7.74027 8.43916 6.87815C8.43916 6.01603 7.74027 5.31714 6.87815 5.31714C6.01603 5.31714 5.31714 6.01603 5.31714 6.87815C5.31714 7.74027 6.01603 8.43916 6.87815 8.43916Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default ImageIconSolid;
